export default __webpack_public_path__ + "beta-maps-examples-user-location-view-thumbnail-480-abf68bef6143ad05027917d1833c36f1.webp";